import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-navy-950 text-white relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-champagne-500/30 to-transparent"></div>
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-champagne-600/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-champagne-500/5 rounded-full blur-3xl"></div>

      <div className="relative px-6 lg:px-12 xl:px-16 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            {/* Logo */}
            <Link to="/" className="inline-block mb-6 transition-transform duration-300 hover:scale-105">
              <img
                src="https://static.readdy.ai/image/fae9e38b84e40674aa7550f041b63695/a464937ca27083cedc8a3bc7a19a7622.jpeg"
                alt="WealthRise Management"
                className="h-16 w-auto"
              />
            </Link>
            
            <h3 className="text-2xl lg:text-3xl font-display font-bold mb-4 text-white">
              Women In Wealth Summit
            </h3>
            <p className="text-sm text-navy-300 mb-8 max-w-md leading-relaxed">
              A private summit for women who move capital and shape legacies. Curated by the WealthRise Management team in Beirut, March 2026.
            </p>
            <div className="flex gap-3">
              {[
                { icon: 'ri-linkedin-fill', url: 'https://linkedin.com', label: 'LinkedIn' },
                { icon: 'ri-instagram-line', url: 'https://instagram.com', label: 'Instagram' },
                { icon: 'ri-twitter-x-line', url: 'https://twitter.com', label: 'Twitter' }
              ].map((social) => (
                <a
                  key={social.label}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-11 h-11 rounded-full border border-navy-700 flex items-center justify-center hover:border-champagne-500 hover:bg-champagne-500/10 transition-all duration-300 cursor-pointer group"
                  aria-label={social.label}
                >
                  <i className={`${social.icon} text-lg text-navy-400 group-hover:text-champagne-400 transition-colors duration-300`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-champagne-400 mb-6 font-semibold">
              Contact
            </h4>
            <div className="space-y-5">
              <div>
                <p className="text-xs text-navy-500 mb-1.5">Location</p>
                <p className="text-sm text-navy-200">Beirut, Lebanon</p>
              </div>
              <div>
                <p className="text-xs text-navy-500 mb-1.5">Email</p>
                <a
                  href="mailto:summit@wealthrisemanagement.com"
                  className="text-sm text-navy-200 hover:text-champagne-400 transition-colors duration-300 inline-block"
                >
                  summit@wealthrisemanagement.com
                </a>
              </div>
              <div>
                <p className="text-xs text-navy-500 mb-1.5">Event Date</p>
                <p className="text-sm text-navy-200">March 2026</p>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-champagne-400 mb-6 font-semibold">
              Quick Links
            </h4>
            <div className="space-y-3">
              {[
                { to: '/about', label: 'About the Summit' },
                { to: '/program', label: 'Program' },
                { to: '/speakers', label: 'Speakers' },
                { to: '/attend', label: 'Request Invitation' },
                { to: '/beirut', label: 'Why Beirut' },
                { to: '/contact', label: 'Contact Us' }
              ].map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="block text-sm text-navy-300 hover:text-champagne-400 transition-all duration-300 hover:translate-x-1"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="relative border-t border-navy-800">
        <div className="px-6 lg:px-12 xl:px-16 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-navy-500">
            © {currentYear} WealthRise Management. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/faq" className="text-xs text-navy-500 hover:text-champagne-400 transition-colors duration-300">
              FAQ
            </Link>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-navy-500 hover:text-champagne-400 transition-colors duration-300"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
